import { applyIframeAspectRatio } from '@utils/function';
import root from 'react-shadow';

interface InnerHTMLProps {
  htmlContent: string;
  height?: string;
  isBlur?: boolean;
  styleContent?: string;
}

const tinymceCSS = (styleContent = '') => `
  .tiny-preview table {
    border-collapse: collapse;
  }
  .tiny-preview table:not([cellpadding]) td,
  .tiny-preview table:not([cellpadding]) th {
    padding: 0.4rem;
  }
  .tiny-preview table[border]:not([border='0']):not([style*='border-width']) td,
  .tiny-preview table[border]:not([border='0']):not([style*='border-width']) th {
    border-width: 1px;
  }
  .tiny-preview table[border]:not([border='0']):not([style*='border-style']) td,
  table[border]:not([border='0']):not([style*='border-style']) th {
    border-style: solid;
  }
  .tiny-preview table[border]:not([border='0']):not([style*='border-color']) td,
  .tiny-preview table[border]:not([border='0']):not([style*='border-color']) th {
    border-color: #ccc;
  }
  .tiny-preview figure {
    display: table;
    margin: 1rem auto;
  }
  .tiny-preview figure figcaption {
    color: #999;
    display: block;
    margin-top: 0.25rem;
    text-align: center;
  }
  .tiny-preview hr {
    border-color: #ccc;
    border-style: solid;
    border-width: 1px 0 0 0;
  }
  .tiny-preview code {
    background-color: #e8e8e8;
    border-radius: 3px;
    padding: 0.1rem 0.2rem;
  }
  .tiny-preview .mce-content-body:not([dir='rtl']) blockquote {
    border-left: 2px solid #ccc;
    margin-left: 1.5rem;
    padding-left: 1rem;
  }
  .tiny-preview .mce-content-body[dir='rtl'] blockquote {
    border-right: 2px solid #ccc;
    margin-right: 1.5rem;
    padding-right: 1rem;
  }
  .tiny-preview img {
    max-width: 100%;
    height: auto;
  }
  .tiny-preview {
    font-weight: normal;
  }
  .tiny-preview ul,
  .tiny-preview ol {
    padding-left: 1.6rem; 
  }
  .tiny-preview iframe {
    max-width: 100%;
    height: fit-content !important;
    display: block;
    border: none;
  }
  .tiny-preview .wallet-address {
    border: none;
    background: transparent;
    padding: 0;
    cursor: pointer;
    font: inherit;
    transition: color 0.2s linear;
  }
  .tiny-preview .wallet-address:hover {
    color: #F80;
  }
  .tiny-preview {
    font-size: 16px;
  }
  .tiny-preview * {
    ${styleContent}
  }
`;

function InnerHTML({
  htmlContent,
  height = 'auto',
  isBlur = false,
  styleContent = '',
}: InnerHTMLProps) {
  const html = applyIframeAspectRatio(htmlContent);

  return (
    <root.div
      style={{ maxHeight: height }}
      className={`relative overflow-hidden w-full ${isBlur ? 'hidden_text' : ''}`}
    >
      <style>{tinymceCSS(styleContent)}</style>
      <div className="tiny-preview" dangerouslySetInnerHTML={{ __html: html }} />
    </root.div>
  );
}

export default InnerHTML;
